import React from 'react';
import PropTypes from 'prop-types';

import { debounce } from '../helpers.js';

import SearchForm from './SearchForm';
import SearchResults from './SearchResults';

import Fetcher from '../src/Fetcher.js';
import SearchService from '../src/SearchService';

class SearchApp extends React.Component {
    constructor(props) {
        super(props);

        const fetcher = new Fetcher();
        // const fetcher = new FakeFetcher();
        this.service = new SearchService(fetcher);

        this.state = {
            query: this.props.defaultQuery,
            searchResult: null,
            loading: true,
        };

        this.fetchResults = debounce(this.fetchResults, 500);
    }

    componentDidMount() {
        if (this.state.query) {
            this.fetchResults(this.state.query);
        }
    }

    fetchResults = (query) => {
        this.setState({ query, loading: true });

        this.service.getResults(query)
            .then(searchResult => this.setState({ searchResult, loading: false }));

        window.history.replaceState(
            { query: this.state.query },
            window.document.title,
            `/zoeken${query.length ? `?q=${encodeURIComponent(query)}` : ''}`,
        );
    };

    handleLoadMore = () => {
        if (!this.state.query.length) {
            return;
        }

        this.setState({ loading: true });

        this.service.getResults(this.state.query, true)
            .then(searchResult => this.setState({ searchResult, loading: false }));
    };

    render = () => (
        <div className='search-page l-block-t l-block-b'>
            <div className='l-container'>
                <h1 className='a-title -center'>Zoeken</h1>

                <SearchForm
                    defaultQuery={this.props.defaultQuery}
                    processQuery={this.fetchResults}
                />
                {this.state.searchResult &&
                    <SearchResults
                        query={this.state.query}
                        result={this.state.searchResult}
                        onLoadMore={this.handleLoadMore}
                        loading={this.state.loading}
                    />
                }
            </div>
        </div>
    );
}

SearchApp.propTypes = {
    defaultQuery: PropTypes.string.isRequired,
};

SearchApp.defaultProps = {
    defaultQuery: '',
};

export default SearchApp;
